import { useContext, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { withTheme } from 'styled-components';

import { getUserGridCampaigns, setUserGridCampaigns, tdasCampaignId } from '../../../api/Optimise';
import TdasLogoV2 from '../../../assets/svg/tdas-v2.svg';
import { AppContext } from '../../../context/AppContext';
import ErrorLabel from '../../ErrorLabel';
import { StyledModalHeader } from '../../Styled';
import WhiteSpinner from '../../WhiteSpinner';

const Success = ({ onHide, theme }) => {
  const { setUserEvents } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    setError(null);
    setUserGridCampaigns(tdasCampaignId)
      .then(() => {
        getUserGridCampaigns().then((res) => setUserEvents(res));
      })
      .catch((error) => {
        console.error(error);
        setError(error.message);
      })
      .finally(() => setLoading(false));
  }, []);
  return (
    <>
      <StyledModalHeader background={theme.colors.gradients.success} closeButton>
        <img src={TdasLogoV2} alt="Turn Down and Save" />
      </StyledModalHeader>
      <Modal.Body className="px-4 pb-3">
        <h1 className="mb-4 text-left">You're signed up to Turn Down and Save</h1>
        <p className="mb-4">Thanks for opting in. We'll let you know when the first Turn Down and Save event is.</p>
        {error && (
          <div className="pt-0 mb-3">
            <ErrorLabel label={error} />
          </div>
        )}
        <Button className="mb-3" onClick={onHide} block>
          {loading ? <WhiteSpinner /> : 'Close'}
        </Button>
      </Modal.Body>
    </>
  );
};
export default withTheme(Success);
